import { apiGet } from '@/store/api';
import { usePortcallStore } from '@/store/portcallStore';

export async function getChecklist(callId: string | number) {
  const result = await apiGet(`checklist/call/${callId}`);
  usePortcallStore().setChecklist(result);
}
